<template>

  <div class="p-fluid report-field">
    <div v-if="guide.label" class="p-grid report-field-header">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label>{{$t('report.'+section+'.'+guide.label)}}</label>
      </div>
    </div>
  </div>

  <div class="p-grid">

    <div v-for="(children) in guide.childrens" :key="children.c_key" style="padding-right: .5rem;" :class="['p-pb-0 p-pt-1','p-col-12 p-sm-12 p-md-6 p-lg-6',{'p-xl-4':!overview}]" >

      
      <div class="abs-title p-ai-center p-mb-2">
        {{$t('report.'+section+'.'+children.c_key)}}
      </div>
      
      <div class="p-grid p-ai-center p-pl-3 p-pr-2" >

        <div v-if="children.c_type=='1A'" :class="['abs-1a p-pl-0 p-pr-3', {'p-col-4 p-text-right': overview}, {'p-col-12': !overview}]">
          <InputNumber v-if="!overview" v-model="values[children.c_key]" 
            @input="dataChanged(children, $event.value)" 
            :disabled="guide.disabled"
            :class="{'p-invalid':children.invalid}"
            :minFractionDigits="1" :maxFractionDigits="1"
            :locale="$i18n.locale" :aria-label="$t('report.'+section+'.'+children.c_key)"
            />  
          <span v-else>{{ values[children.c_key] ?? '' }}</span>
          <span> A</span>
        </div>

        <div v-if="children.c_type=='3A'" :class="['p-col-4 abs-3a p-pl-0 p-pr-3', {'p-text-right': overview}]">
          <InputNumber v-if="!overview" v-model="values[children.c_key].first" 
            @input="dataChanged(children, $event.value, 'first')" 
            :disabled="guide.disabled"
            :class="{'p-invalid':children.invalid}"
            :minFractionDigits="1" :maxFractionDigits="1"
            :locale="$i18n.locale" :aria-label="$t('report.'+section+'.'+children.c_key)"
            />  
          <span v-else>{{ values[children.c_key].first ?? '' }}</span>
          <span> A</span>
        </div>
        <div v-if="children.c_type=='3A'" :class="['p-col-4 abs-3a p-pl-0 p-pr-3', {'p-text-right': overview}]">
          <InputNumber v-if="!overview" v-model="values[children.c_key].second" 
            @input="dataChanged(children, $event.value, 'second')" 
            :disabled="guide.disabled"
            :class="{'p-invalid':children.invalid}"
            :minFractionDigits="1" :maxFractionDigits="1"
            :locale="$i18n.locale" :aria-label="$t('report.'+section+'.'+children.c_key)"
            />  
          <span v-else>{{ values[children.c_key].second ?? '' }}</span>
          <span> A</span>
        </div>
        <div v-if="children.c_type=='3A'" :class="['p-col-4 abs-3a p-pl-0 p-pr-3', {'p-text-right': overview}]">
          <InputNumber v-if="!overview" v-model="values[children.c_key].third" 
            @input="dataChanged(children, $event.value, 'third')" 
            :disabled="guide.disabled"
            :class="{'p-invalid':children.invalid}"
            :minFractionDigits="1" :maxFractionDigits="1"
            :locale="$i18n.locale" :aria-label="$t('report.'+section+'.'+children.c_key)"
            />  
          <span v-else>{{ values[children.c_key].third ?? '' }}</span>
          <span> A</span>
        </div>

      </div>
      
    </div>
  </div>

</template>

<script>
export default {
  emits: ['update:data'],
  components: {
  },
  props: {
      section: String,
      guide: Object,
      data: Object,
      overview: Boolean
    },
  data() {
    return {
      values: {}
    }
  },
  computed: {
  },
  created() {
    for(let children of this.guide.childrens) {
      if(children.c_type === '3A') {
        try {
          let abs = [];
          if(this.data[children.c_key]) {
            abs = this.data[children.c_key].split("|||");
            this.values[children.c_key] = {
              first: abs[0] ? Number(abs[0]) : null,
              second: abs[1] ? Number(abs[1]) : null,
              third: abs[2] ? Number(abs[2]) : null
            };
          } else {
            this.values[children.c_key] = {
              first: null,
              second: null,
              third: null
            };
          }
        } catch(err) {
          console.error("ERROR DECODING OF "+children.c_key+": "+this.data[children.c_key]);
          this.values[children.c_key] = {
            first: null,
            second: null,
            third: null
          };
        }
      } else {
        try {
          this.values[children.c_key] = this.data[children.c_key] ? Number(this.data[children.c_key]) : null;
        } catch(err) {
          console.error("ERROR DECODING OF "+children.c_key+": "+this.data[children.c_key]);
          this.values[children.c_key] = null;
        }
      }
    }
  },
  mounted() {
  },
  watch: {
    'guide.disabled': 'resetField',
    'guide.hidden': 'resetField',
  },
  methods: {
    dataChanged(children, newValue, what) {
      console.log("VALUES "+JSON.stringify(this.values[children.c_key]))
      console.log("WHAT "+what)
      console.log("NEW VALUE "+newValue)
      if(children.c_type === '3A') {
        let rawVal = {
          first: this.values[children.c_key].first ?? '',
          second: this.values[children.c_key].second ?? '',
          third: this.values[children.c_key].third ?? ''
        }
        rawVal[what] = newValue!=null ? newValue : '';
        this.values[children.c_key][what] = newValue;
        this.$emit("update:data", { key: children.c_key, value: rawVal.first+"|||"+rawVal.second+"|||"+rawVal.third });
      } else {
        this.values[children.c_key] = newValue;
        this.$emit("update:data", { key: children.c_key, value: newValue!=null ? ''+newValue : null });
      }
    },
    resetField() {
      if(this.guide.hidden || this.guide.disabled) {
        for(let key in this.values) {
          this.values[key] = null;
        }
      }
    }
    
  }
}
</script>

<style scoped>

</style>